import { useContext } from 'react';
import SectionContext from '../../SectionContext';
import { type EditorSectionWithoutRelations } from '@/lib/types';
import ModelsContext from '@/pages/EditorPage/ChallengeModelsEditor/ModelsContext';
import VisibilityDatesManager, {
  type VisibilityDatesManagerProps,
} from '../../VisibilityDatesManager';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';

type SectionVisibilityDatesProps = Omit<
  VisibilityDatesManagerProps<EditorSectionWithoutRelations>,
  'variant' | 'fieldOrSection' | 'updateFieldOrSectionInLocalState'
>;

const SectionVisibilityDates = (props: SectionVisibilityDatesProps) => {
  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { section } = useContext(SectionContext);

  return (
    <VisibilityDatesManager
      variant="section"
      fieldOrSection={section}
      updateFieldOrSectionInLocalState={(
        updatedSection: EditorSectionWithoutRelations,
      ): void => {
        setModels(models => {
          models[selectedModelId].sections[section.id] = {
            ...models[selectedModelId].sections[section.id],
            ...updatedSection,
          };
        });
      }}
      {...props}
    />
  );
};

export default SectionVisibilityDates;
